import instance from '../_http'

export default {
  /**
   * 添加
   * @param {*} website
   * @returns
   */
  add: (website) => {
    return instance.post('/api/travel/car-rule', website)
  },
  /**
   *  删除
   */
  remove: (id) => {
    return instance.delete(`/api/travel/car-rule/${id}`)
  },
  /**
   * 更新
   * @param {*} website
   * @returns
   */
  update: (website) => {
    return instance.put('/api/travel/car-rule', website)
  },
  /**
   * 查询
   * @param {*} query
   * @returns
   */
  query: (query, page) => {
    return instance.get('/api/travel/car-rule', {
      params: {
        ...query,
        page: page.page,
        size: page.size,
        sort: page.sort
      }
    })
  },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
  detail: (id) => {
    return instance.get(`/api/travel/car-rule/${id}`)
  }
}
